<template>
	<section class="video" v-if="$i18n.locale=='en'">
		<div class="container">

			<div class="content-text">
				<h2
				v-html="$t('Video.title')"
				v-wow="{
				'animation-name': 'fadeInUp',
				'animation-duration': '1s',
			}"
			></h2>
		</div>

		<div class="fadeInLeft animated video">

			<div class="video-inner">   
				<!-- VIDEO IMAGE -->
				<div class="video-container">
					<div class="video-content">
						<div class="video-cover see-video lazy" :data-key="$t('Video.id')" :style="'background-image:url(https://i3.ytimg.com/vi/'+$t('Video.id')+'/maxresdefault.jpg)'"  @click="youtube" >
							<div class="video-primary" :style="contentStyle">
								<span class="srt">title</span><span class="srt">Play Icon</span>
								<div><img src="~@/assets/img/play.png" alt="" role="presentation"></div>
							</div>
							<div class="video-primary" v-html="contentVideo"></div>
						</div> 
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
</template>

<script>
	export default {
		name: 'Video',
		data() {
			return {
				contentStyle: 'display:block;',
				contentVideo: '',
			}
		},
		methods: {
			youtube() {
				this.contentStyle = 'display:none;';
				this.contentVideo= '<iframe class="video-itself" src="https://www.youtube.com/embed/Vg_AUznYeWs?autoplay=1&loop=1&playlist=Vg_AUznYeWs&mute=1" frameborder="0" allowfullscreen></iframe>'
			}
		}
	}

</script>

<style scoped lang="scss">
	h2 {
		margin-bottom: 30px;
		text-align: center;
	}
</style>
